<div class="form-preview-container" *ngIf="Template">
  <div class="preview-header">
    <h2>{{ Template.Name }}</h2>
    <p *ngIf="Template.Description">{{ Template.Description }}</p>
    <span class="version-badge">V{{ Template.Version }}</span>
  </div>
  <div class="preview-body">
    <app-form-fill-cdms [fields]="Template.Fields" [mode]="'preview'"></app-form-fill-cdms>
  </div>
</div>
